import { CONFIRMING_REQUEST_STATUS_MAP } from 'lib/consts';

import type { StatusChipType } from '../index';

type ConfirmingStatusKey = keyof typeof CONFIRMING_REQUEST_STATUS_MAP;

const CONFIRMING_STATUS_CHIP_MAP: Record<ConfirmingStatusKey, StatusChipType> =
  {
    CREATED: 'success',
    IN_REVIEW: 'warning',
    ACCEPTED: 'success',
    IN_TRANSFER: 'info',
    REJECTED: 'error',
    ACTIVE: 'success',
    COMPLETED: 'success',
  };

const LABEL_TO_KEY = Object.fromEntries(
  Object.entries(CONFIRMING_REQUEST_STATUS_MAP).map(([k, v]) => [v, k]),
) as Record<string, ConfirmingStatusKey>;

export const getConfirmingStatusLabel = (statusOrKey: string): string => {
  if (statusOrKey in CONFIRMING_REQUEST_STATUS_MAP) {
    return CONFIRMING_REQUEST_STATUS_MAP[statusOrKey as ConfirmingStatusKey];
  }
  return statusOrKey;
};

export const getConfirmingStatusChipType = (
  statusOrLabel: string,
): StatusChipType => {
  const key =
    statusOrLabel in CONFIRMING_REQUEST_STATUS_MAP
      ? (statusOrLabel as ConfirmingStatusKey)
      : LABEL_TO_KEY[statusOrLabel];
  return (key && CONFIRMING_STATUS_CHIP_MAP[key]) ?? 'default';
};
